import { ISuggestion } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { TEDEKKontodelkombinationKOMBINATIONEnum } from '../../../../../../globalQueryTypes';
import { IValue } from '../../../../../../Types/UrvalTypes';
import { IAttestKodbehorighetUrval } from '../../../../_Common/Components/KonteringManager/KonteringContext';
import {
  IKontodel,
  IKontodelDef,
} from '../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import { getKontodelByKontodelsdef } from '../../../../_Common/Components/KonteringManager/validateKonteringForAttestUtils';
import { koddelInInterval } from '../../../../_Common/Utils/kodbehorighetUtils';
import { isKoddelInKodbeh } from '../../../Rutiner/EkonomiskAnalys/Components/SideMenu/Components/UrvalOchSummering/Components/Urval/Utils/UrvalUtils';
import { ITemplateKoddel } from '../Components/BokforderContext/BokforderContextManager';
import { createKodstrang } from '../Hooks/useValidateBokforder';
import {
  BokforderType__Associations_Rader,
  BokforderType__Associations_Rader__Associations_Kontodel1,
} from '../Queries/_QueryTypes/BokforderType';
import {
  getSelectedBaskontoInternKontoValue,
  isBokfOrderKontodelValid,
} from './BokforderUtils';
import { isInternkontoEnum } from './validationUtils';

export const filterInternalAndExternalKoddelar = (
  selectedBaskontonInBokforder: BokforderType__Associations_Rader__Associations_Kontodel1[],
  baskontoDelsDef: IKontodelDef | undefined,
  kontodel: IKontodel,
  bokfDate: Date
): boolean => {
  let isInternKonto: isInternkontoEnum = isInternkontoEnum.NotSet;

  if (selectedBaskontonInBokforder) {
    if (selectedBaskontonInBokforder.length === 0) {
      isInternKonto = isInternkontoEnum.NotSet;
    } else if (
      getSelectedBaskontoInternKontoValue(
        selectedBaskontonInBokforder[0],
        baskontoDelsDef
      ) === true
    ) {
      isInternKonto = isInternkontoEnum.True;
    } else {
      isInternKonto = isInternkontoEnum.False;
    }
  } else {
    isInternKonto = isInternkontoEnum.False;
  }

  return isBokfOrderKontodelValid(kontodel, bokfDate, isInternKonto);
};

export const filterKoddelInKodbeh = (
  kontodel: IKontodel,
  attestKodbehorighetUrval: IAttestKodbehorighetUrval[]
) => {
  let suggestions: ISuggestion[] = [];
  if (isKoddelInKodbeh(kontodel, attestKodbehorighetUrval)) {
    const suggestion: ISuggestion = {
      name: `${kontodel.kontodel} - ${kontodel.benamning}`,
      value: kontodel.id,
      data: {
        BENAMNING: kontodel.benamning,
        KONTODEL: kontodel.kontodel,
        KontodelBenamning: `${kontodel.kontodel} - ${kontodel.benamning}`,
        id: kontodel.id,
      },
    };
    suggestions.push(suggestion);
  }
  return suggestions;
};

export const filterKontodelInKombinationsvilkor = (
  enhancedSelectedKontodelar: IKontodel[] | undefined,
  kontodelOption: IKontodel
): boolean => {
  if (enhancedSelectedKontodelar == undefined) {
    return true;
  }

  let isKontodelOk = false;

  for (let index = 0; index < enhancedSelectedKontodelar.length; index++) {
    const enhancedSelectedKontodel = enhancedSelectedKontodelar[index];

    if (enhancedSelectedKontodel.kombinationsVillkor.length == 0) {
      isKontodelOk = true;
    } else {
      const kombVillkorForSelectedKontodel =
        enhancedSelectedKontodel.kombinationsVillkor.filter(
          kombVillkor =>
            kombVillkor.kombOrdningsNr === kontodelOption.ordningsNr
        );

      if (
        kombVillkorForSelectedKontodel.length === 0 ||
        kombVillkorForSelectedKontodel.some(
          kombVillkor =>
            kontodelOption.kontodel >= kombVillkor.fromKontodel &&
            kontodelOption.kontodel <= kombVillkor.toKontodel
        )
      ) {
        isKontodelOk = true;
      } else {
        return false;
      }
    }
  }

  return isKontodelOk;
};

export const getAllKombinationNonValidOrdningsNr = (
  allKontodelDefs: IKontodelDef[],
  bokfDate: Date,
  currentRow: BokforderType__Associations_Rader
): number[] => {
  let result: number[] = [];

  const kodstrang = createKodstrang(currentRow, allKontodelDefs);

  const baskontoDel = kodstrang?.kontodelar.find(
    kodstrangDel => kodstrangDel.ordningsNr === 1
  );

  if (baskontoDel) {
    const baskonto = getKontodelByKontodelsdef(
      allKontodelDefs,
      baskontoDel.ordningsNr,
      baskontoDel.kontodel,
      bokfDate
    );

    if (baskonto && baskonto.kombinationer) {
      for (let index = 0; index < baskonto?.kombinationer?.length; index++) {
        const kombination = baskonto?.kombinationer[index];

        if (
          kombination.kombination ===
          TEDEKKontodelkombinationKOMBINATIONEnum.FAR_EJ_KOMBINERAS
        ) {
          result.push(kombination.kombOrdningsNr);
        }
      }
    }
  }

  return result;
};

export const filterOnTemplateRowValidInterval = (
  kontodel: IKontodel,
  currentTemplateKontodel: ITemplateKoddel
): boolean => {
  const validInterval = currentTemplateKontodel.options?.validInterval ?? '';
  const validValues = validInterval.split(',');
  let isKontodelValid: boolean = false;

  for (let index = 0; index < validValues.length; index++) {
    const validValue = validValues[index];
    const interval = validValue.includes('-')
      ? validValue.split('-')
      : [validValue, validValue];

    const value: IValue = {
      id: validInterval,
      toValue: interval[1],
      value: interval[0],
    };

    isKontodelValid = koddelInInterval(kontodel, value);
    if (isKontodelValid) {
      return isKontodelValid;
    }
  }

  return isKontodelValid;
};
